import React from "react";
import line from "../assets/line.png";
import First from "../assets/First.jpg";
import Eh from "../assets/Eh.png";
import EhrDraw from "./EhrDraw";
import EhrInfographics from "../assets/EhrInfographics.svg";
import EhrPath from "../assets/EhrPath.svg";
import ColourLogo from "../assets/ColourLogo.svg";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";


const EhrPage = () => {
  return (
    <div className="min-h-screen scroll-smooth">
      {/* Hero Section with Video Background */}
     <section className="relative h-[50vh] sm:h-[60vh] flex items-center justify-center text-white overflow-hidden">
  {/* 🎥 Video Background */}
  <video
    className="absolute top-0 left-0 w-full h-full object-cover z-0"
    src="/Product780.mp4"
    autoPlay
    muted
    loop
    playsInline
  />
  {/* 🌫️ Transparent Overlay */}
  <div className="absolute inset-0 bg-gradient-to-r from-[#0A1B60] via-[#1F2E8A] to-[#4B0FA3] opacity-40 z-10" />


  {/* 📝 Foreground */}
  <div className="max-w-7xl mx-auto px-4 sm:px-6 w-full z-10 flex flex-col items-center text-center">
    <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white font-bold mb-3 sm:mb-4">
      WISE EHR
    </h1>
   <h2
  className="uppercase font-extrabold text-transparent text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl leading-snug sm:leading-tight"
  style={{
    fontFamily: "Calibri, sans-serif",
    WebkitTextStroke: "1.8px #ffffff",
    letterSpacing: "0.04em",
  }}
>
  Empowering Clinicians, <br className="sm:hidden" /> Enriching Care
</h2>

  </div>
</section>

      {/* Vision Section */}
      <section className="pt-12 sm:pt-[100px] pb-8 sm:pb-12 px-4 sm:px-6 bg-white flex flex-col items-center justify-center snap-start w-full !h-auto">
        <div className="max-w-6xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Left Side - Paragraph */}
          <div>
            <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg">
              <span className="font-bold text-gray-900">WISE EHR</span> transforms
              the way healthcare providers interact with patient data. Designed
              for accuracy, accessibility, and adaptability, it offers a unified
              view of medical history, treatments, diagnostics, and ongoing care.
              Built with clinical efficiency in mind, it bridges gaps between
              caregivers, systems, and patients—while maintaining full regulatory
              compliance.{" "}
              <span className="font-bold text-gray-900">WISE EHR</span> is a
              secure, intuitive, and interoperable platform designed to
              centralize patient health data, streamline clinical workflows, and
              enhance care coordination across departments.
            </p>
          </div>

         {/* Right Side - Image */}
<div className="flex justify-center">
  <img
    src={Eh}
    alt="WISE HIS illustration"
    className="max-w-[220px] sm:max-w-[240px] md:max-w-[260px] lg:max-w-[280px] object-contain"
  />
</div>

        </div>
      </section>

      {/* Infographics */}
      <section className="bg-white flex justify-center items-center py-4 sm:py-5">
        <img
          src={EhrInfographics}
          alt="EHR Infographics"
          className="w-full max-w-[350px] sm:max-w-[600px] md:max-w-[800px] h-auto"
        />
      </section>

      {/* Draw Section */}
      <section className="w-full bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white relative overflow-hidden flex items-center justify-center py-6 sm:py-10">
        <EhrDraw />
      </section>

      {/* Path Image */}
<section className="bg-white flex justify-center items-center p-0 m-0">
  <img 
    src={EhrPath} 
    alt="EHR Path" 
    className="max-w-5xl w-full h-auto object-contain"
  />
</section>
<section className="relative bg-gradient-to-r from-[#050A3A] via-[#1A0F6B] to-[#3E0E9F] overflow-hidden">
  {/* White curved part */}
  <div className="absolute top-[180px] left-0 w-full">
    <div className="bg-white rounded-t-[12rem] sm:rounded-t-[14rem] h-[120vh]"></div>
  </div>

  {/* Content */}
  <div className="relative z-10 px-6 sm:px-10 md:px-16 lg:px-24 pt-24 pb-16">
    {/* Top heading part */}
    <div className="text-center mt-[160px] mb-12">
       <h2
  className="text-4xl sm:text-5xl font-bold mb-2 text-[#6F7DFF]"
>
  Collaborate for Success
</h2>
      <p className="text-gray-700 text-lg sm:text-xl font-medium">
        Working together with others fosters innovation, creativity, and a greater sense of accomplishment.
      </p>
    </div>

    {/* Four-column footer part */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-gray-800">
      {/* About Us */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">ABOUT US</h3>
        <img src={ColourLogo} alt="Wissenstil Solutions" className="w-40 mb-4" />
      <p className="mb-4 leading-relaxed">
  Wissenstil Solutions is a specialized software company driving digital innovation.
</p>
      </div>

      {/* Services */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">SERVICES</h3>
        <ul className="space-y-2">
          <li>Image Analysis</li>
          <li>Anomaly Detection</li>
          <li>Medical Coding</li>
        </ul>
      </div>

  
{/* Useful Links */}
<div>
  <h3 className="font-bold mb-4 text-gray-900">USEFUL LINKS</h3>
  <ul
    className="space-y-2 text-gray-800"
    style={{ fontFamily: 'Calibri, sans-serif' }}
  >
    {[
      { name: "About Us", path: "/about" },
      { name: "Wise Services", path: "/services" },
      { name: "Wise Products", path: "/products" },
      { name: "Contact Us", path: "/contact" },
    ].map((link, index) => (
      <li
        key={index}
        className="transition-transform duration-300 hover:translate-x-2 text-base sm:text-lg md:text-xl"
      >
        <Link
          to={link.path}
          onClick={() => (window.location.href = link.path)}
          className="relative inline-block hover:text-purple-700 transition-colors duration-200 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-purple-700 hover:after:w-full after:transition-all after:duration-300"
        >
          {link.name}
        </Link>
      </li>
    ))}
  </ul>
</div>

      {/* Contact */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">CONTACT US</h3>
        <p>
          Wissenstil Solutions Private Ltd.<br />
          Brigade IRV Centre, 09th &amp; 10th Floor,<br />
          Nallurahalli, Whitefield,<br />
          Bangalore, 560066.
        </p>
     

<div className="mt-4 space-y-3 text-white">
  <p className="flex items-center space-x-3">
    <Phone className="w-5 h-5 text-gray-900" />
    <span className="text-gray-900 font-medium">+91 9986158307</span>
  </p>
  <p className="flex items-center space-x-3">
    <Mail className="w-5 h-5 text-gray-900" />
    <span className="text-gray-900 font-medium">Manish.palliyil@wissenstil.com</span>
  </p>
</div>
      </div>
    </div>
  </div>
</section>

    </div>
  );
};

export default EhrPage;
